const packageJSON = require('../package.json');

const { name, applicationName } = packageJSON;

module.exports = {
  vault: {
    url: `https://vault.peya.co/v1/secret/web-micro-site-${name}/stg`,
    enabled: true,
  },
  apiGateway: {
    url: 'http://client-api-gateway.stg.peja.co',
    timeout: 5000,
  },
  countryServices: {
    url: 'http://countries-service.stg.peja.co',
    timeout: 5000,
  },
  authServices: {
    url: 'http://auth.stg.peja.co',
    timeout: 5000,
  },
  locationService: {
    url: 'http://locations-service.stg.peja.co',
    timeout: 5000,
  },
  locationModuleFederation: {
    id: 'webLocation',
    moduleName: 'Location',
    manifest: '/mfe/web-location',
  },
  redis: {
    web: {
      host: {
        latam01: 'redis-peya-cache-web-stg-wr.stg.peja.co',
        latam02: 'redis-peya-cache-web-stg-wr.stg.peja.co',
        latam03: 'redis-peya-cache-web-stg-wr.stg.peja.co',
      },
      port: 6379,
      cookieName: '__Secure-peya.sid',
      sessionName: 'mWeb',
      envName: 'staging',
      cookieConfig: {
        httpOnly: true,
        secure: true,
        sameSite: 'lax',
        maxAge: 5400000,
      },
    },
    webApps: {
      host: 'redis-peya-cache-web-stg-wr.stg.peja.co',
      port: 6379,
      cookieName: `__Secure-${applicationName}.${name}.sid`,
      sessionName: `${applicationName}.${name}`,
      envName: 'staging',
      cookieConfig: {
        httpOnly: true,
        secure: true,
        sameSite: 'lax',
        maxAge: 5400000,
      },
    },
  },
  metrics: {
    enabled: true,
    sampleRate: 1,
    clientName: 'datadog',
    events: [
      'LOADED_EMPTY_FILTER',
      'BT_FILTER_CLICK',
      'ITEM_CLICK',
      'ITEM_TOP_POSITION_CLICK',
      'ITEM_SECOND_RANGE_CLICK',
      'ITEM_THIRD_RANGE_CLICK',
      'ITEM_FOURTH_RANGE_CLICK',
      'VENDOR_SECOND_RANGE_CLICK',
      'VENDOR_THIRD_RANGE_CLICK',
      'VENDOR_FOURTH_RANGE_CLICK',
      'DELIVERY_TIME_FILTER_CLICK',
      'DISTANCE_FILTER_CLICK',
      'RANKING_FILTER_CLICK',
      'TERMS_AND_CONDITIONS_CLICK',
      'BACK_BUTTON_CLICK',
      'VENDOR_TOP_POSITION_CLICK',
      'VENDOR_CLICK',
      'LOADED_EMPTY_STATE',
      'SERVER_ERROR',
      'CLIENT_ERROR',
      'LOADED_EMPTY_ITEM',
      'LOADED_ERROR_ITEM',
    ],
  },
  fwf: {
    httpRequestTimeout: 1500,
    flagTimeToLive: 10,
    localFwfUrl: 'http://fwf-client-api.stg.peja.co',
  },
  resources: {
    url: 'https://stg-web-commons.pystatic.com',
    js: [
      'https://stg-web-commons.pystatic.com/react/17.0.2/production.min.js',
      'https://stg-web-commons.pystatic.com/react-dom/17.0.2/production.min.js',
    ],
  },
};
